import type { InjectionKey } from "vue"
import type { ModelFacade } from "@/utils/useEngineModel/ModelFacade"

export const MODEL_TOKEN = "$modelApi"

/**
 * Injection token used to `provide` the `ModelFacade` instance.
 * Can be used to pass to `inject()`
 *
 * ```js
 * inject(MODEL_INJECTION_KEY)
 * ```
 */
export const MODEL_INJECTION_KEY: InjectionKey<ModelFacade> =
  Symbol(MODEL_TOKEN)
